import { ApiError } from '../ErrorInterfaces'

interface IMetadata {
  [x: string]: string
}

export interface ICoupon {
  id: string
  name?: string
  /**
   * Value is 'coupon'
   */
  object: 'coupon'

  /**
   * Amount (in the currency specified) that will be taken off the subtotal of any invoices for this customer.
   */
  amount_off: number

  created: number

  /**
   * If amount_off has been set, the currency of the amount to take off.
   */
  currency: string

  /**
   * One of "forever", "once", and "repeating".
   * Describes how long a customer who applies this coupon will get the discount.
   */
  duration: 'forever' | 'once' | 'repeating'

  /**
   * If duration is repeating, the number of months the coupon applies. Null if coupon duration is forever or once.
   */
  duration_in_months: number

  livemode: boolean

  /**
   * Maximum number of times this coupon can be redeemed, in total, before it is no longer valid.
   */
  max_redemptions: number

  metadata: IMetadata

  /**
   * Percent that will be taken off the subtotal of any invoices for this customer for the duration
   * of the coupon. For example, a coupon with percent_off of 50 will make a $100 invoice $50 instead.
   */
  percent_off: number

  /**
   * Date after which the coupon can no longer be redeemed
   */
  redeem_by: number

  /**
   * Number of times this coupon has been applied to a customer.
   */
  times_redeemed: number

  /**
   * Taking account of the above properties, whether this coupon can still be applied to a customer
   */
  valid: boolean
}

export interface CouponStateInterface {
  loaded: boolean
  value?: ICoupon
  error?: ApiError
}
